(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ontime-components", [], factory);
	else if(typeof exports === 'object')
		exports["ontime-components"] = factory();
	else
		root["ontime-components"] = factory();
})(this, function() {
return 